<template>
  <el-dialog
    v-drag
    title="导出"
    :visible.sync="dialogVisible"
    width="506px"
    :show-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div v-loading="loading" class="content">
      <el-row>
        <el-col class="panel" :span="12">
          <div class="btn" @click="exportOrigin">原始列表</div>
        </el-col>
        <el-col class="panel" :span="12">
          <div class="btn" @click="exportProfit">汇总表</div>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>
  <script>
  import { derive } from '@/utils/common'
  export default {
    components: {},
    props: {
      dialogVisible: {
        type: Boolean,
        default: false
      },
      filter: {
        type: Object,
        default: function() {
          return {}
        }
      }
    },
    data() {
      return {
        loading: false
      }
    },
    watch: {},
    methods: {
      cancel() {
        this.$emit('cancel')
      },
      async exportOrigin() {
          this.loading = true
          await derive('Payable/exportPayable', 'post', this.filter)
          this.loading = false
      },
      async exportProfit() {
          this.loading = true
          await derive('payable/exportPayableSummary', 'post', this.filter)
          this.loading = false
      }
    }
  }
  </script>
  <style lang="less" scoped>
  .content {
    width: 100%;
    .panel {
      display: flex;
      justify-content: center;
    }
    .btn {
      width: 180px;
      height: 40px;
      background:  rgb(18,88,188);
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
    }
  }
  </style>

